export function color(c) {
  if (!c) return ''
  if (c == 'А') return '#FF2C32'
  else if (c == 'Б') return '#139FEC'
  else if (c == 'В') return '#FDFB0A'
  else return ''
}
